import React from 'react';
import PortalLogin from './portal/PortalLogin';
import { STUDENT_PORTAL_ENABLED, getStudentSession, studentLogin } from '../../config/studentApi';

const PortalEstudiantil: React.FC = () => (
  <PortalLogin
    enabled={STUDENT_PORTAL_ENABLED}
    basePath="/portal-estudiantil"
    badge="Acceso estudiantes"
    title="Portal Estudiantil"
    intro="Consulta tus notas, el avance de tu programa y tus datos académicos desde cualquier lugar."
    hint="Ingresa con el usuario o correo y la contraseña que te envió CECAP."
    userLabel="Usuario o correo"
    userPlaceholder="usuario"
    disabledNotice="El Portal Estudiantil estará disponible muy pronto."
    hasSession={() => Boolean(getStudentSession())}
    login={studentLogin}
  />
);

export default PortalEstudiantil;
